/** @format */

import { updatePolicy } from '../services/updatePolicies';

interface UpdatePolicyInput {
  status?: string;
  premium?: number;
  billingDate?: string;
}

export const useUpdatePolicy = () => {
  const updatePolicyData = async (policyId: string, updateData: UpdatePolicyInput) => {
    try {
      const response = await updatePolicy(policyId, updateData);
      return response;
    } catch (err: any) {
      throw err;
    }
  };

  return {
    updatePolicyData,
  };
};
